// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"ri_a bhs_a bhs_r bhs_sb bhs_ry bhs_rz","GroupsGrid__row__item":"ri_b bhs_be bhs_rz"};